// THE theme switch (canvas 2026-09-16, adopted app-wide 2026-09-23). Two
// themes: 'light' (day, the default) and 'dark' (night). The choice is a
// per-viewer convenience in localStorage; the tokens live in
// src/styles/globals.css and every Tailwind colour utility reads them, so a
// switch here restyles the whole app with no component edits.
const KEY = 'tracon.theme';
export const THEMES = ['light', 'dark'];

export function getTheme() {
  try {
    const v = window.localStorage.getItem(KEY);
    if (THEMES.includes(v)) return v;
  } catch (e) { /* storage unavailable: day */ }
  return 'light';
}

export function applyTheme(theme) {
  const t = THEMES.includes(theme) ? theme : 'light';
  const el = document.documentElement;
  if (t === 'light') el.removeAttribute('data-theme'); else el.setAttribute('data-theme', t);
  try { window.localStorage.setItem(KEY, t); } catch (e) { /* ignore */ }
  return t;
}

export function toggleTheme() {
  return applyTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

export function initTheme() {
  return applyTheme(getTheme());
}
